import { Popover } from "antd";
import React from "react";
import AuthorCard from "./AuthorCard";

interface IProps {
  index: number;
  author: {
    lastName: string;
    foreName: string;
    initials: string;
    affiliationInfo: string[];
  };
  dict: {
    lastName: string;
    foreName: string;
    initials: string;
    followed: string;
    affInfo: string;
    not: string;
    authorInfo: string;
  };
  length: number;
}

const AuthorDescription: React.FC<IProps> = ({
  index,
  author,
  length,
  dict,
}) => {
  const des = [
    { label: dict.lastName, content: author.lastName },
    { label: dict.foreName, content: author.foreName },
    { label: dict.initials, content: author.initials },
    { label: dict.followed, content: dict.not },
    {
      label: dict.affInfo,
      content: author.affiliationInfo,
    },
  ];

  return (
    <Popover
      content={<AuthorCard des={des} />}
      title={dict.authorInfo}
      key={index}
    >
      <span>
        {author.lastName} {author.initials} {index === length - 1 ? " " : ", "}
      </span>
    </Popover>
  );
};

export default AuthorDescription;
